import { useGlobalConfigContext } from '../../../global-config'
import { TENANTS_WITH_MARKETPLACE_FUNCTIONALITY } from '../../../marketplace'
import { type TENANT } from '../../../tenant'

type ProductPageContextData = {
  isMarketplace: boolean
  tenant: TENANT
}

export const useGetProductPageContextData = (): ProductPageContextData => {
  const globalConfig = useGlobalConfigContext()
  const isMarketplace = TENANTS_WITH_MARKETPLACE_FUNCTIONALITY.has(
    globalConfig.tenant,
  )

  return {
    isMarketplace,
    tenant: globalConfig.tenant,
  }
}
